import { render } from "./ImageSize.vue?vue&type=template&id=51c5f978"
import script from "./ImageSize.vue?vue&type=script&lang=ts"
export * from "./ImageSize.vue?vue&type=script&lang=ts"
script.render = render

export default script